<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="hierarchy">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 层级管理
        </span>
        <div class="w_normalNav">
          <button class="GreenSmBtn" @click="toAddNew">新增</button>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable
            apiUrl="operation/management/findAll"
            :parent="self"
            :config="config"
            :other="other"
            ref="Hierarchy"
          >
            <template slot="last">
              <el-table-column label="人员管理" width="350" align="center">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconcheck"
                    type="text"
                    size="small"
                    @click="see(scope.$index, scope.row, true)"
                  >详情</el-link>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="350" align="center">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconedit"
                    type="text"
                    size="small"
                    @click="toEdit(scope.$index, scope.row, true)"
                  >编辑</el-link>
                  <!-- <el-link icon="iconfont iconadd" type="text" size="small">添加</el-link> -->
                  <el-link
                    icon="iconfont icondelete"
                    type="text"
                    size="small"
                    @click="deleteHierarchy(scope.$index, scope.row)"
                  >删除</el-link>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <!-- dialog -->
        <el-dialog
          class="editDialog"
          :visible.sync="displayForm"
          :title="title"
          :close-on-click-modal="false"
        >
          <el-form ref="addEquipment" :model="addEquipment" v-show="!loadingStatus" :rules="rules">
            <el-form-item label="层级名称" prop="name">
              <el-input placeholder="请输入层级名称" v-model.trim="addEquipment.name"></el-input>
            </el-form-item>
            <el-form-item label="职责描述" prop="remark">
              <el-input type="textarea" placeholder="请输入职责描述" v-model="addEquipment.remark"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="displayForm = false">取 消</el-button>
            <el-button class="confirmButton" type="primary" @click="submitForm">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入层级名称", trigger: "blur" }],
        remark: [
          { max: 300, message: "层级描述不可多于150字", trigger: "blur" },
          { required: true, message: "请输入职责描述", trigger: "blur" }
        ]
      },
      tabName: "hierarchy",
      loading: true,
      form_jsgl: {},
      displayForm: false,
      loadingStatus: false,
      showTable: true,
      other: {},
      //弹框标题
      title: "",
      status: "",
      addEquipment: {
        name: "",
        remark: "",
        people: ""
      },
      edit_id: ""
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "name",
          label: "管理层级"
        },
        {
          prop: "counts",
          label: "人数"
        }
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable")
  },
  methods: {
    //人员管理
    see(index, row) {
      this.$router.push({name: 'personnel', params: {id: row.id}});
    },
    //新增
    toAddNew() {
      this.status = 1;
      this.title = "新增层级";
      this.displayForm = true;
      this.addEquipment = {
        name: "",
        remark: "",
        people: ""
      };
      if (this.$refs["addEquipment"])
        this.$refs["addEquipment"].clearValidate();
    },
    //编辑
    toEdit(index, row) {
      this.status = 2;
      this.title = "修改层级信息";
      this.displayForm = true;
      this.edit_id = row.id;
      this.addEquipment.name = row.name;
      this.addEquipment.remark = row.remark;
      if (this.$refs["addEquipment"])
        this.$refs["addEquipment"].clearValidate();
    },
    //保存
    submitForm() {
      this.$refs["addEquipment"].validate(valid => {
        if (valid) {
          if (this.status === 1) {
            this.$axiospost("operation/management/save", {
              name: this.addEquipment.name,
              remark: this.addEquipment.remark
            }).then(res => {
              if (res.data.status === "555") {
                this.$message.warning("该名称已存在！");
              } else {
                this.$message.success("新增成功！");
                this.displayForm = false;
                this.$nextTick(this.$refs.Hierarchy.getData);
              }
            });
          } else if (this.status === 2) {
            this.$axiospost("operation/management/save", {
              id: this.edit_id,
              name: this.addEquipment.name,
              remark: this.addEquipment.remark
            }).then(res => {
              if (res.data.status === "555") {
                this.$message.warning("该名称已存在！");
              } else {
                this.$message.success("修改成功！");
                this.displayForm = false;
                this.$nextTick(this.$refs.Hierarchy.getData);
              }
            });
          }
        }
      });
    },
    //删除
    deleteHierarchy(index, row) {
      this.$confirm("是否删除该层级？", "删除操作", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axiosdelete("operation/management/delete", {
          params: {
            id: row.id
          }
        }).then(res => {
          this.$message.success("删除成功!");
          this.$nextTick(this.$refs.Hierarchy.getData);
        });
      }).catch(()=>{

      })
    }
  }
};
</script>

<style lang="less" scoped>
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-textarea__inner {
  border: 1px solid #3d4963;
  border-radius: 0;
  width: 310px;
  background: transparent;
  color: #cacaca;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/mission/hierarchy.vue